import * as React from 'react';
import { useState, useEffect } from 'react';
import Faceplate from '../components/Faceplate';
import { TypeSystemEnum } from './hmilib/hmiglobal';
import SingleWindow from './MainPage/dcs/centumvp/SingleWindow';
import SingleWindowTab from './MainPage/dcs/centumvp/components/Tabs/SingleWindowTab';
import { Console } from 'console';
import { event } from 'jquery';
import { MnemoParams } from './hmilib/hooks/CentumVPScript';

export interface IFaceplate {
    id: number;
    Height: number;
    Width: number;
    Top: number;
    Left: number;
    indexFaceplate: string;
    title: string;
    collapse: boolean;
    size: string;
    active?: boolean;
    CallbackRender?: (id: string) => void;
    SelectActiveTab?: (id: number) => void;
    OnClose?: () => void;
    OnCollapse?: (index: string, height: number, width: number) => void;
    onPositionChange?: (newLeft: number, newTop: number, indexFaceplate: string) => void;
}

export const SelectFaceplate = {
    faceplateName: '',
    parenMnemoName: ''
};

function FaceplateManager() {
    const [arrayFaceplate, setArrayFaceplate] = useState<any[]>([]);
    const [countFaceplate, setCountFaceplate] = useState<number>(5);

    const OnEvent = React.useCallback(
        (event: any) => {
            let TempArray = [...arrayFaceplate];
            let TempItem = TempArray.find((item) => item.index == event.detail.index);

            if (TempArray)
                TempArray.forEach((item) => {
                    item.active = false;
                });

            if (TempItem != undefined) {
                const Faceplates = document.getElementsByClassName('FaceplateMainDiv');
                for (let i = 0; i < Faceplates.length; i++) {
                    const slide = Faceplates[i] as HTMLElement;
                    slide.style.zIndex = '45';
                    slide.classList.remove('action');
                }

                const ActionFaceplates = document.getElementById(TempItem.index + 'MainDiv');
                if (ActionFaceplates != null) {
                    ActionFaceplates.style.zIndex = '50';
                    ActionFaceplates.classList.add('action');
                }

                if (event.detail.width != null) {
                    if (TempItem.width === undefined && TempItem.height === undefined) {
                        TempItem.width = event.detail.width + 6;
                        TempItem.height = event.detail.height + 24;
                    }
                    if (event.detail.title != '') TempItem.title = event.detail.title;

                    if (TempItem.collapse === undefined) {
                        TempItem.collapse = true;
                    }
                }

                if (TempItem.position == 'cursor') {
                    TempItem.Top = window.Mouse.clientY + 2;
                    TempItem.Left = window.Mouse.clientX + 2;
                } else {
                    TempItem.Top = (window.innerHeight - event.detail.height + 6) / 2;
                    TempItem.Left = (window.innerWidth - event.detail.width + 24) / 2;
                }

                if (!TempItem.collapse) {
                    TempItem.collapse = true;
                }

                TempItem.active = true;

                if (TempItem.size.toUpperCase() != 'SPECIALWIN' && window.TypeSystem == TypeSystemEnum.CentumVP) {
                    findTagMnemo(TempItem.title);
                }

                setArrayFaceplate(TempArray);
            } else {
                TempItem = event.detail;
                if (TempItem.collapse === undefined) {
                    TempItem.collapse = true;
                }

                if (window.TypeSystem == TypeSystemEnum.CentumVP) {
                    let specialWinItem = TempArray.find((item) => item.size.toUpperCase() === 'SPECIALWIN');

                    if (specialWinItem !== undefined) {
                        const specialWinItemIndex = TempArray.indexOf(specialWinItem);
                        TempArray[specialWinItemIndex] = TempItem;
                        setArrayFaceplate(TempArray);
                    } else {
                        TempArray.push(TempItem);
                        if (TempArray.length > countFaceplate) TempArray.splice(0, 1);
                        setArrayFaceplate(TempArray);
                    }
                } else {
                    TempArray.push(TempItem);
                    if (TempArray.length > countFaceplate) TempArray.splice(0, 1);
                    setArrayFaceplate(TempArray);
                }
            }
        },
        [arrayFaceplate]
    );

    const CloseEventFaceplate = React.useCallback(
        (event: any) => {
            let index = event.detail.index;
            let TempItemIndex = arrayFaceplate.findIndex((item) => item.index == event.detail.index);
            if (TempItemIndex != -1) CloseItem(TempItemIndex);
        },
        [arrayFaceplate]
    );

    useEffect(() => {
        document.addEventListener('AddFaceplateManager', OnEvent);
        document.addEventListener('CloseFaceplateManager', CloseEventFaceplate);
        return () => {
            document.removeEventListener('AddFaceplateManager', OnEvent);
            document.removeEventListener('CloseFaceplateManager', CloseEventFaceplate);
        };
    }, [OnEvent, CloseEventFaceplate]);

    //Сменить активный таб
    function SetActiveTab(indexActive: number) {
        const newArray = arrayFaceplate.map((item, index) => ({
            ...item,
            active: index === indexActive ? true : false
        }));

        setArrayFaceplate(newArray);
    }

    //Поиск мнемосхемы для выбранной позиции
    function findTagMnemo(TagName: string) {
        const MnemoParamsMap = new Map(Object.entries(MnemoParams));
        if (MnemoParamsMap.size !== 0) {
            for (let [key, value] of MnemoParamsMap) {
                if (new Set(value.Alarms).has(TagName)) {
                    SelectFaceplate.faceplateName = TagName;
                    SelectFaceplate.parenMnemoName = key;
                    break;
                }
            }
        }
    }

    //свернуть Окно
    function ToggleCollapse(index: string, height?: number, width?: number) {
        let updatedArray = arrayFaceplate.map((item) => {
            if (item.index === index) {
                item.collapse = !item.collapse;
                if (height !== undefined && width !== undefined) {
                    item.height = height;
                    item.width = width;
                }
            }
            return item;
        });
        setArrayFaceplate(updatedArray);
    }

    //Закрыть Окно
    const CloseItem = (index: number) => {
        let TempArray = [...arrayFaceplate];
        TempArray.splice(index, 1);
        setArrayFaceplate(TempArray);
    };

    const SavePosition = (newLeft: number, newTop: number, indexFaceplate: string) => {
        setArrayFaceplate((prevArray) =>
            prevArray.map((faceplate) =>
                faceplate.index === indexFaceplate ? { ...faceplate, Left: newLeft, Top: newTop } : faceplate
            )
        );
    };

    const createFaceplate = (
        item: string,
        index: number,
        CallbackRender: any,
        title: string,
        height: number,
        width: number,
        Top: number,
        Left: number,
        size?: any,
        collapse?: any,
        active?: boolean
    ) => {
        //setActionFaceplate(arrayFaceplate.length-1);
        if (window.TypeSystem == TypeSystemEnum.CentumVP) {
            if (collapse === true) {
                return (
                    <>
                        <SingleWindow
                            key={item}
                            id={index}
                            Height={height}
                            Width={width}
                            Top={Top}
                            Left={Left}
                            indexFaceplate={item}
                            title={title}
                            CallbackRender={CallbackRender}
                            size={size}
                            collapse={collapse}
                            active={active}
                            SelectActiveTab={SetActiveTab}
                            OnClose={() => {
                                CloseItem(index);
                            }}
                            OnCollapse={ToggleCollapse}
                            onPositionChange={SavePosition}></SingleWindow>
                    </>
                );
            }
        } else {
            return (
                <Faceplate
                    key={item}
                    id={index}
                    Height={height}
                    Width={width}
                    Top={Top}
                    Left={Left}
                    indexFaceplate={item}
                    title={title}
                    size={size}
                    collapse={collapse}
                    OnClose={() => {
                        CloseItem(index);
                    }}
                    CallbackRender={CallbackRender}></Faceplate>
            );
        }
    };

    const createFaceplateTab = (
        item: string,
        index: number,
        height: number,
        width: number,
        Top: number = 15,
        Left: number = 15,
        collapse: any,
        title: string,
        size: any
    ) => {
        if (window.TypeSystem == TypeSystemEnum.CentumVP) {
            return (
                <SingleWindowTab
                    indexFaceplate={item}
                    id={index}
                    Height={height}
                    Width={width}
                    Top={Top}
                    Left={Left}
                    collapse={collapse}
                    title={title}
                    size={size}
                    OnCollapse={ToggleCollapse}></SingleWindowTab>
            );
        }
    };

    if (window.TypeSystem == TypeSystemEnum.CentumVP) {
        return (
            <React.Fragment>
                {arrayFaceplate.map((item, index) => {
                    return (
                        <React.Fragment key={`faceplate-${item.index}`}>
                            {createFaceplate(
                                item.index,
                                index,
                                item.CallbackRender,
                                item.title,
                                item.height,
                                item.width,
                                item.Top,
                                item.Left,
                                item.size,
                                item.collapse,
                                item.active
                            )}
                        </React.Fragment>
                    );
                })}
                <div className="centumvp-window-singlewindow-tab">
                    {arrayFaceplate.map((item, index) => {
                        return (
                            <div key={`tab-${item.index}`}>
                                {createFaceplateTab(
                                    item.index,
                                    index,
                                    item.height,
                                    item.width,
                                    item.Top,
                                    item.Left,
                                    item.collapse,
                                    item.title,
                                    item.size
                                )}
                            </div>
                        );
                    })}
                </div>
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                {arrayFaceplate.map((item, index) => {
                    return createFaceplate(
                        item.index,
                        index,
                        item.CallbackRender,
                        item.title,
                        item.height,
                        item.width,
                        item.Top,
                        item.Left
                    );
                })}
            </React.Fragment>
        );
    }
}

export default FaceplateManager;
